import { GET_TEAM_PAST_EVENTS } from 'actions/Types';

const initialState = {
  itemCount: 0,
  events: [],
  pageCount: 0,
  page: 0
};

export default (state = initialState, action) => {
  if (action.type === `${GET_TEAM_PAST_EVENTS}_SUCCESS`) {
    const { itemCount, pageCount, events = [], page } = action.payload;

    const nextEvents = page === 1 ? events : [...state.events, ...events];

    return {
      events: nextEvents,
      itemCount,
      pageCount,
      page
    };
  }

  return state;
};
